<div class="dialog-container">
  <div class="image" [style.background-image]="'url(' + data.imageUrl + ')'">
    <div class="compress-container" (click)="onCancel()"></div>
    <i class="fas fa-compress" (click)="onCancel()"></i>
  </div>
</div>
